import config from '@/config/config';

export default {
	endpoints: {
		baseUrl: config.apiURL,

		defaults: {
			headers: {
				'Content-Type': 'application/json',
			},
		},

		action: {
			list: {
				url: '/actions',
				method: 'GET',
			},
			get: {
				url: '/actions/:actionId',
				method: 'GET',
			},
			add: {
				url: '/actions',
				method: 'POST',
			},
			update: {
				url: '/actions/:actionId',
				method: 'PUT',
			},
			remove: {
				url: '/actions/:actionId',
				method: 'DELETE',
			},
		},

		address: {
			lookup: {
				url: '/addresses',
				method: 'GET',
			},
		},

		board: {
			list: {
				url: '/boards',
				method: 'GET',
			},
			get: {
				url: '/boards/:boardId',
				method: 'GET',
			},
			add: {
				url: '/boards',
				method: 'POST',
			},
			update: {
				url: '/boards/:boardId',
				method: 'PUT',
			},
			remove: {
				url: '/boards/:boardId',
				method: 'DELETE',
			},
		},

		brigadierPanel: {
			list: {
				url: '/safety-panel',
				method: 'GET',
			},
			monitor: {
				url: '/safety-panel/monitor',
				method: 'GET',
			},
		},

		client: {
			list: {
				url: '/clients',
				method: 'GET',
			},
			get: {
				url: '/clients/:clientId',
				method: 'GET',
			},
			getTheme: {
				url: '/clients/theme/:slug',
				method: 'GET',
			},
			add: {
				url: '/clients',
				method: 'POST',
			},
			update: {
				url: '/clients/:clientId',
				method: 'PUT',
			},
			remove: {
				url: '/clients/:clientId',
				method: 'DELETE',
			},
			getFile: {
				url: '/clients/:clientId/files/:fileId',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			removeFile: {
				url: '/clients/:clientId/files/:fileId',
				method: 'DELETE',
			},
		},

		contract: {
			list: {
				url: '/clients/:clientId/contracts',
				method: 'GET',
			},
			get: {
				url: '/clients/:clientId/contracts/:contractId',
				method: 'GET',
			},
			listDevices: {
				url: '/clients/:clientId/contracts/:contractId/devices',
				method: 'GET',
			},
			add: {
				url: '/clients/:clientId/contracts',
				method: 'POST',
			},
			update: {
				url: '/clients/:clientId/contracts/:contractId',
				method: 'PUT',
			},
			remove: {
				url: '/clients/:clientId/contracts/:contractId',
				method: 'DELETE',
			},
			getFile: {
				url: '/clients/:clientId/contracts/:contractId/files/:fileId',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			removeFile: {
				url: '/clients/:clientId/contracts/:contractId/files/:fileId',
				method: 'DELETE',
			},
		},

		dashboard: {
			getTotalMonthlyEvents: {
				url: '/dashboard/events/monthly',
				method: 'GET',
			},
			getTotalYearEventVision: {
				url: '/dashboard/events/vision/year',
				method: 'GET',
			},
			getTodaysEventsCount: {
				url: '/dashboard/events/today',
				method: 'GET',
			},
			countTotalDevices: {
				url: '/dashboard/devices/count',
				method: 'GET',
			},
			getClientProximityEvents: {
				url: '/dashboard/events/proximity',
				method: 'GET',
			},
			countDeviceEvents: {
				url: '/dashboard/events/device',
				method: 'GET',
			},
			listProductStock: {
				url: '/dashboard/products/stock',
				method: 'GET',
			},
			listClientsEvents: {
				url: '/dashboard/clients/events',
				method: 'GET',
			},
			countClients: {
				url: '/dashboard/clients/count',
				method: 'GET',
			},
			listClientEmployeeEvents: {
				url: '/dashboard/employees/events',
				method: 'GET',
			},
			countClientEquipments: {
				url: '/dashboard/equipments/count',
				method: 'GET',
			},
			countClientEmployees: {
				url: '/dashboard/employees/count',
				method: 'GET',
			},
			listVisionEvents: {
				url: '/v2/events/types/vision',
				method: 'GET',
			},
		},
		deviceDocumentsFile: {
			get: {
				url: '/api/devicefile/getDeviceFiles/:deviceId',
				method: 'GET',
			},
			downloadDocumentFile: {
				url: '/api/devicefile/download/:deviceId/files/:fileId',
				method: 'GET',
			},
			uploadDocumentFile: {
				url: '/api/devicefile/uploadfile',
				method: 'POST',
			},
			deleteDocumentFile: {
				url: '/api/devicefile/:deviceId/files/:fileId',
				method: 'DELETE',
			},
		},
		deviceMaintenance: {
			list: {
				url: '/api/device_maintenance/:deviceId',
				method: 'GET',
			},
			update: {
				url: '/api/device_maintenance/:deviceId/:maintenanceId',
				method: 'PUT',
			},
			add: {
				url: '/api/device_maintenance/:deviceId',
				method: 'POST',
			},
			remove: {
				url: '/api/device_maintenance/:deviceId/:maintenanceId',
				method: 'DELETE',
			},
		},
		device: {
			findAll: {
				url: '/v2/devices',
				method: 'GET',
			},
			list: {
				url: '/v2/devices/association/types',
				method: 'GET',
			},
			findConnections: {
				url: '/v2/devices/connection/entity',
				method: 'GET',
			},

			get: {
				url: '/v2/devices/:deviceId',
				method: 'GET',
			},
			loadHistory: {
				url: '/v2/devices/:deviceId/histories',
				method: 'GET',
			},
			add: {
				url: '/v2/devices',
				method: 'POST',
			},
			update: {
				url: '/v2/devices/:deviceId',
				method: 'PUT',
			},
			remove: {
				url: '/v2/devices/:deviceId',
				method: 'DELETE',
			},
			validateBulk: {
				url: '/v2/devices/bulk/validate',
				method: 'POST',
			},
			insertBulk: {
				url: '/v2/devices/bulk',
				method: 'POST',
			},
			updateExcelBulk: {
				url: '/v2/devices/bulk/excel/batch',
				method: 'PUT',
			},
			updateBulk: {
				url: '/v2/devices/bulk/batch',
				method: 'PUT',
			},
			removeBulk: {
				url: '/v2/devices/bulk/batch',
				method: 'DELETE',
			},
			getPublicDevice: {
				url: '/public/devices',
				method: 'GET',
			},
			getDeviceContractClient: {
				url: '/v2/devices/association/client',
				method: 'GET',
			},
			getReport: {
				url: '/v2/devices/maintenance/:maintenanceId/file/:fileId',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			removeFile: {
				url: '/v2/devices/maintenance/:maintenanceId/file/:fileId',
				method: 'DELETE',
			},
		},
		camera: {
			list: {
				url: '/api/cameras',
				method: 'GET',
			},
			getCamera: {
				url: '/api/camera/:cameraId',
				method: 'GET',
			},
			getCameraEngineById: {
				url: '/api/camera/:cameraId/engine',
				method: 'GET',
			},
			getCameraAssociation: {
				url: '/api/cameras/associations',
				method: 'GET',
			},
			getCameraAllEngines: {
				url: '/api/cameras/engines',
				method: 'GET',
			},
			getCameraByIdEngineById: {
				url: '/api/camera/:cameraId/engine/:engineId',
				method: 'GET',
			},
			getCameraPassword: {
				url: '/api/camera/:cameraId/password',
				method: 'GET',
			},
			listEvents: {
				url: '/api/cameras/events',
				method: 'GET',
			},
			add: {
				url: '/api/camera',
				method: 'POST',
			},
			addCameraEngine: {
				url: '/api/camera/engine',
				method: 'POST',
			},
			update: {
				url: '/api/camera/:cameraId',
				method: 'PATCH',
			},
			updateCameraEngine: {
				url: '/api/camera/:cameraId/engine/:engineId',
				method: 'PATCH',
			},
			remove: {
				url: '/api/camera/:cameraId',
				method: 'DELETE',
			},
			removeCameraEngine: {
				url: '/api/camera/:cameraId/engine/:engineId',
				method: 'DELETE',
			},
		},
		employee: {
			list: {
				url: '/employees',
				method: 'GET',
			},
			get: {
				url: '/employees/:employeeId',
				method: 'GET',
			},
			getDevices: {
				url: '/employees/:employeeId/associations',
				method: 'GET',
			},
			add: {
				url: '/employees',
				method: 'POST',
			},
			update: {
				url: '/employees/:employeeId',
				method: 'PUT',
			},
			remove: {
				url: '/employees/:employeeId',
				method: 'DELETE',
			},
			removeFile: {
				url: '/employees/:employeeId/files/:fileId',
				method: 'DELETE',
			},
			removeDocumentFile: {
				url: '/employees/:employeeId/document/file/:fileId',
				method: 'DELETE',
			},
			downloadEmployeeDocumentFile: {
				url: '/employees/download/:employeeId/document/file/:fileId',
				method: 'GET',
			},
			listEvents: {
				url: '/employees/:employeeId/events',
				method: 'GET',
			},
			validateBulk: {
				url: '/employees/bulk/validate',
				method: 'POST',
			},
			insertBulk: {
				url: '/employees/bulk',
				method: 'POST',
			},
			updateBulk: {
				url: '/employees',
				method: 'PATCH',
			},
			removeBulk: {
				url: '/employees',
				method: 'DELETE',
			},
		},
		equipmentFile: {
			get: {
				url: '/api/equipmentfile/getEquipmentFiles/:equipmentId',
				method: 'GET',
			},
			uploadEquipmentFile: {
				url: '/api/equipmentfile/uploadfile',
				method: 'POST',
			},
			removeEquipmentFile: {
				url: '/api/equipmentfile/:equipmentId/files/:fileId',
				method: 'DELETE',
			},
			downloadEquipmentFile: {
				url: '/api/equipmentfile/download/:equipmentId/file/:fileId',
				method: 'GET',
			},
		},
		equipment: {
			list: {
				url: '/equipments',
				method: 'GET',
			},
			get: {
				url: '/equipments/:equipmentId',
				method: 'GET',
			},
			getDevices: {
				url: '/equipments/:equipmentId/associations',
				method: 'GET',
			},
			getEquipmentAssociationByClient: {
				url: '/equipments/client/association',
				method: 'GET',
			},
			add: {
				url: '/equipments',
				method: 'POST',
			},
			update: {
				url: '/equipments/:equipmentId',
				method: 'PUT',
			},
			remove: {
				url: '/equipments/:equipmentId',
				method: 'DELETE',
			},
			listEvents: {
				url: '/equipments/:equipmentId/events',
				method: 'GET',
			},
			validateBulk: {
				url: '/equipments/bulk/validate',
				method: 'POST',
			},
			insertBulk: {
				url: '/equipments/bulk',
				method: 'POST',
			},
			updateBulk: {
				url: '/equipments/bulk',
				method: 'PATCH',
			},
			removeBulk: {
				url: '/equipments',
				method: 'DELETE',
			},
		},

		event: {
			list: {
				url: '/events',
				method: 'GET',
			},
			findSynoptic: {
				url: '/v2/events/synoptics',
				method: 'GET',
			},
			listByType: {
				url: '/v2/events/types/:type',
				method: 'GET',
			},
			findLastEvents: {
				url: '/v2/events/last',
				method: 'GET',
			},
			listPanicNotifications: {
				url: '/v2/events/panic',
				method: 'GET',
			},
		},

		file: {
			upload: {
				url: '/files',
				method: 'POST',
			},
		},

		firmware: {
			list: {
				url: '/firmwares',
				method: 'GET',
			},
			get: {
				url: '/firmwares/:firmwareId',
				method: 'GET',
			},
			add: {
				url: '/firmwares',
				method: 'POST',
			},
			update: {
				url: '/firmwares/:firmwareId',
				method: 'PUT',
			},
			remove: {
				url: '/firmwares/:firmwareId',
				method: 'DELETE',
			},
		},

		insight: {
			list: {
				url: '/clients/:clientId/insights',
				method: 'GET',
			},
			get: {
				url: '/clients/:clientId/insights/:insightId',
				method: 'GET',
			},
			add: {
				url: '/clients/:clientId/insights',
				method: 'POST',
			},
			update: {
				url: '/clients/:clientId/insights/:insightId',
				method: 'PUT',
			},
			remove: {
				url: '/clients/:clientId/insights/:insightId',
				method: 'DELETE',
			},
		},

		integration: {
			list: {
				url: '/integrations',
				method: 'GET',
			},
			get: {
				url: '/integrations/:integrationId',
				method: 'GET',
			},
			add: {
				url: '/integrations',
				method: 'POST',
			},
			update: {
				url: '/integrations/:integrationId',
				method: 'PUT',
			},
			remove: {
				url: '/integrations/:integrationId',
				method: 'DELETE',
			},
		},

		logSchema: {
			list: {
				url: '/log-schemas',
				method: 'GET',
			},
			get: {
				url: '/log-schemas/:logSchemaId',
				method: 'GET',
			},
			add: {
				url: '/log-schemas',
				method: 'POST',
			},
			update: {
				url: '/log-schemas/:logSchemaId',
				method: 'PUT',
			},
			remove: {
				url: '/log-schemas/:logSchemaId',
				method: 'DELETE',
			},
		},

		logType: {
			list: {
				url: '/log-types',
				method: 'GET',
			},
			get: {
				url: '/log-types/:logTypeId',
				method: 'GET',
			},
			getEventTypeErrors: {
				url: '/log-types/events/error',
				method: 'GET',
			},
			getEventErrorById: {
				url: '/log-types/events/error/:logTypeId',
				method: 'GET',
			},
			add: {
				url: '/log-types',
				method: 'POST',
			},
			update: {
				url: '/log-types/:logTypeId',
				method: 'PUT',
			},
			remove: {
				url: '/log-types/:logTypeId',
				method: 'DELETE',
			},
		},

		permissionGroup: {
			list: {
				url: '/groups',
				method: 'GET',
			},
			listEntities: {
				url: '/groups/entities',
				method: 'GET',
			},
			get: {
				url: '/groups/:permissionGroupId',
				method: 'GET',
			},
			add: {
				url: '/groups',
				method: 'POST',
			},
			update: {
				url: '/groups/:permissionGroupId',
				method: 'PUT',
			},
			remove: {
				url: '/groups/:permissionGroupId',
				method: 'DELETE',
			},
		},

		place: {
			list: {
				url: '/places',
				method: 'GET',
			},
			get: {
				url: '/places/:placeId',
				method: 'GET',
			},
			getDevices: {
				url: '/places/:placeId/associations',
				method: 'GET',
			},
			getCameras: {
				url: '/places/:placeId/cameras/associations',
				method: 'GET',
			},
			add: {
				url: '/places',
				method: 'POST',
			},
			update: {
				url: '/places/:placeId',
				method: 'PUT',
			},
			remove: {
				url: '/places/:placeId',
				method: 'DELETE',
			},
			listEvents: {
				url: '/places/:placeId/events',
				method: 'GET',
			},
			downloadPlaceFile: {
				url: '/places/download/:placeId/file/:fileId',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			removePlaceFile: {
				url: '/places/:placeId/file/:fileId',
				method: 'DELETE',
			},
		},
		product: {
			list: {
				url: '/products',
				method: 'GET',
			},
			exportList: {
				url: '/products',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			get: {
				url: '/products/:productId',
				method: 'GET',
			},
			add: {
				url: '/products',
				method: 'POST',
			},
			update: {
				url: '/products/:productId',
				method: 'PUT',
			},
			remove: {
				url: '/products/:productId',
				method: 'DELETE',
			},
		},

		report: {
			exportClients: {
				url: '/reports/clients',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			exportEvents: {
				url: '/reports/events',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			exportDevices: {
				url: '/reports/devices',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			exportEquipments: {
				url: '/reports/equipments',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			exportEmployees: {
				url: '/reports/employees',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			exportPlaces: {
				url: '/reports/places',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			exportGroups: {
				url: '/reports/groups',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			exportMaintenances: {
				url: '/reports/devices/maintenance',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			exportDeviceBatteryLevel: {
				url: '/reports/devices/battery/level',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
		},

		role: {
			list: {
				url: '/roles',
				method: 'GET',
			},
			listUserRoles: {
				url: '/users/:userId/roles',
				method: 'GET',
			},
		},

		safety: {
			matchFace: {
				url: '/employees/faces/match',
				method: 'POST',
			},
			searchRegistration: {
				url: '/employees/registration/:registration',
				method: 'GET',
			},
			registerAccess: {
				url: '/employees/events',
				method: 'PATCH',
			},
		},

		tag: {
			list: {
				url: '/tags',
				method: 'GET',
			},
			get: {
				url: '/tags/:tagId',
				method: 'GET',
			},
			update: {
				url: '/tags/:tagId',
				method: 'PUT',
			},
			remove: {
				url: '/tags/:tagId',
				method: 'DELETE',
			},
		},

		tagAssociation: {
			find: {
				url: '/tags/associations',
				method: 'GET',
			},
			save: {
				url: '/tags/associations',
				method: 'POST',
			},
		},

		user: {
			login: {
				url: '/sessions?version=1',
				method: 'POST',
			},
			register: {
				url: '/site/customers',
				method: 'POST',
			},
			requestPasswordReset: {
				url: '/users/credentials',
				method: 'PATCH',
			},
			resetPassword: {
				url: '/users/credentials',
				method: 'PATCH',
			},
			rememberAccount: {
				url: '/users/credentials',
				method: 'PATCH',
			},
			renewToken: {
				url: '/sessions/:sessionId/access/new',
				method: 'GET',
			},
			list: {
				url: '/users',
				method: 'GET',
			},
			exportList: {
				url: '/users',
				method: 'GET',
				options: {
					responseType: 'blob',
				},
			},
			get: {
				url: '/users/:userId',
				method: 'GET',
			},
			add: {
				url: '/users',
				method: 'POST',
			},
			update: {
				url: '/users/:userId',
				method: 'PATCH',
			},
			remove: {
				url: '/users/:userId',
				method: 'DELETE',
			},
		},

		zoneMap: {
			list: {
				url: '/zone-maps',
				method: 'GET',
			},
			monitor: {
				url: '/zone-maps/monitor',
				method: 'GET',
			},
			forceExit: {
				url: '/zone-maps/exit',
				method: 'POST',
			},
		},

		engine: {
			list: {
				url: '/engine',
				method: 'GET',
			},
			get: {
				url: '/engine/:engineId',
				method: 'GET',
			},
			add: {
				url: '/engine',
				method: 'POST',
			},
			getAllContracts: {
				url: '/engine/contracts',
				method: 'GET',
			},
			listEngines: {
				url: '/engine/associations',
				method: 'GET',
			},
			getEngineByClient: {
				url: '/engine/clients/engine',
				method: 'GET',
			},
			update: {
				url: '/engine/:engineId',
				method: 'PUT',
			},
			remove: {
				url: '/engine/:engineId',
				method: 'DELETE',
			},
		},
	},
};
